import React, { useEffect, useRef, useState } from "react";

import Props from "./props";
import Styled from "./styled";

const TextareaAutogrow: React.FC<Props> = ({ onChange, editedValue, placeholder }) => {
    const ref: any = useRef(null);
    const [height, setHeight] = useState(0);
    const rows = (editedValue as string).split("\n").length;
    useEffect(() => {
        const style = window.getComputedStyle(ref.current);
        const lineHeight = parseFloat(style.lineHeight ? style.lineHeight : "d");
        const outlineWidth = parseFloat(style.outlineWidth ? style.outlineWidth : "d");
        const height = lineHeight * rows + outlineWidth;
        if (ref.current.scrollHeight > height) {
            setHeight(ref.current.scrollHeight);
        } else {
            setHeight(height);
        }
    }, [editedValue, setHeight, rows]);
    let props: any = {
        ref,
        onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            return onChange(e.target.value);
        },
        value: editedValue,
        style: {
            height
        }
    };
    if (placeholder) {
        props.placeholder = placeholder;
    }
    return <Styled {...props} />;
};

export default TextareaAutogrow;
